import { useEffect, useState } from 'react';
export function useKeyboardEvent() {
    const [keyboardEvent, setKeyboardEvent] = useState(true);
    useEffect(() => {
        function onPointerDown() {
            setKeyboardEvent(false);
        }
        function onInitialPointerMove(e) {
            var _a;
            const target = e === null || e === void 0 ? void 0 : e.target;
            if (((_a = target === null || target === void 0 ? void 0 : target.nodeName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'html') {
                return;
            }
            setKeyboardEvent(false);
            removeInitialPointerMoveListeners();
        }
        function addInitialPointerMoveListeners() {
            document.addEventListener('mousemove', onInitialPointerMove);
            document.addEventListener('mousedown', onInitialPointerMove);
            document.addEventListener('mouseup', onInitialPointerMove);
            document.addEventListener('pointermove', onInitialPointerMove);
            document.addEventListener('pointerdown', onInitialPointerMove);
            document.addEventListener('pointerup', onInitialPointerMove);
            document.addEventListener('touchmove', onInitialPointerMove);
            document.addEventListener('touchstart', onInitialPointerMove);
            document.addEventListener('touchend', onInitialPointerMove);
        }
        function removeInitialPointerMoveListeners() {
            document.removeEventListener('mousemove', onInitialPointerMove);
            document.removeEventListener('mousedown', onInitialPointerMove);
            document.removeEventListener('mouseup', onInitialPointerMove);
            document.removeEventListener('pointermove', onInitialPointerMove);
            document.removeEventListener('pointerdown', onInitialPointerMove);
            document.removeEventListener('pointerup', onInitialPointerMove);
            document.removeEventListener('touchmove', onInitialPointerMove);
            document.removeEventListener('touchstart', onInitialPointerMove);
            document.removeEventListener('touchend', onInitialPointerMove);
        }
        function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) {
                return;
            }
            setKeyboardEvent(true);
        }
        function onVisibilityChange(_e) {
            if (document.visibilityState === 'hidden') {
                setKeyboardEvent(true);
                addInitialPointerMoveListeners();
            }
        }
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('mousedown', onPointerDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('touchstart', onPointerDown, true);
        document.addEventListener('visibilitychange', onVisibilityChange, true);
        addInitialPointerMoveListeners();
        return () => {
            document.removeEventListener('keydown', onKeyDown, true);
            document.removeEventListener('mousedown', onPointerDown, true);
            document.removeEventListener('pointerdown', onPointerDown, true);
            document.removeEventListener('touchstart', onPointerDown, true);
            document.removeEventListener('visibilitychange', onVisibilityChange, true);
            removeInitialPointerMoveListeners();
        };
    }, [setKeyboardEvent]);
    return keyboardEvent;
}
//# sourceMappingURL=useKeyboardEvent.js.map